import { Card, LinearProgress } from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '../../components/page-wrapper'
import { BreadcrumbItem } from '../../components/breadcrumbs'
import { Nonprofit } from '../../models'
import { defaultItemsCount } from '../../settings/home-page-settings'
import { ListedItemDetailsComponent } from './listed-item-details-component'
import { useListedItemDetailsPage } from './listed-item-details-page.hooks'
import { useListedItemDetailsComponentStyles } from './listed-item-details-page.styles'

export const ListedItemDetailsPage: React.FC = () => {
  const classes = useListedItemDetailsComponentStyles()
  const { t } = useTranslation()
  const {
    detailProps,
    getNonprofitInfo,
    loading,
    deliveryType,
    setInStoreDeliveryType,
    nonprofitProps,
  } = useListedItemDetailsPage()

  const [nonprofitInfo, setNonprofitInfo] = useState<Partial<Nonprofit>>({})

  useEffect(() => {
    if (detailProps) {
      getNonprofitInfo(
        detailProps.nonprofitName ? detailProps.nonprofitName : ''
      )
    }
  }, [detailProps, getNonprofitInfo])

  useEffect(() => {
    if (nonprofitProps) {
      setNonprofitInfo(nonprofitProps ? nonprofitProps : {})
    }
  }, [nonprofitProps])

  const fullDetailProps = {
    ...detailProps,
    nonprofit: nonprofitInfo,
  }

  const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
    const searchCrumb = { label: t('header.menu.search'), to: '/search' as const }

    if (!detailProps) {
      if (!loading) return []
      return [
        searchCrumb,
        { label: '…' },
        { label: '…' },
        { label: '…' },
      ]
    }

    const nonprofit = { ...nonprofitInfo, ...(nonprofitProps ?? {}) }
    const categoryId = nonprofit.nonprofitCategoryId
    const nonprofitId = nonprofit.nonprofitId
    const categoryName = nonprofit.nonprofitCategoryName?.trim()
    const categoryLabel = categoryName || '…'
    const nonprofitLabel =
      detailProps.nonprofitName?.trim() || (loading ? '…' : '—')
    const itemLabel = detailProps.name?.trim() || (loading ? '…' : '—')

    return [
      searchCrumb,
      {
        label: categoryLabel,
        to:
          categoryId != null
            ? `/search?nonprofitCategoryId=${categoryId}`
            : undefined,
      },
      {
        label: nonprofitLabel,
        to:
          categoryId != null && nonprofitId != null
            ? `/search?pageIndex=1&pageSize=${defaultItemsCount}&nonprofitCategoryId=${categoryId}&nonprofitId=${nonprofitId}`
            : undefined,
      },
      { label: itemLabel },
    ]
  }, [detailProps, loading, nonprofitInfo, nonprofitProps, t])

  return (
    <div className={classes.pageSurface}>
      {loading && <LinearProgress />}
      <PageWrapper
        title=""
        displayGoBackButton={true}
        goBackNavPath="/search"
        breadcrumbItems={breadcrumbItems}
      >
        <Card elevation={0}>
          <div className={classes.mainHolder}>
            {/*@ts-ignore*/}
            <ListedItemDetailsComponent
              {...fullDetailProps}
              loading={loading}
              deliveryType={deliveryType}
              setInStoreDeliveryType={setInStoreDeliveryType}
            />
          </div>
        </Card>
      </PageWrapper>
    </div>
  )
}
